import {queryOptions} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {WorkoutsDependencies} from '../dependencies';
import {keys} from './keys';

export type GetActiveWorkoutQueryDependencies = Pick<WorkoutsDependencies, 'controllers'>;

export const getActiveWorkoutQuery = ({controllers}: GetActiveWorkoutQueryDependencies) =>
  queryOptions({
    queryKey: keys.active(),
    queryFn: () => controllers.workoutController.getActive().then(unwrap),
  });
